// KWANKGM04330_近代化資金案件詳細（マイページ）
import React from 'react';
import TopArea from '../../molecules/TopArea';
import { StepNavigation as StepType } from '../../types/Template';
import { status_code_list } from '../../Const';
import LoadingModal from '../../molecules/LoadingModal';
import ReceptionResult from '../../templates/ReceptionResult';
import AgreementInfo from '../../templates/AgreementInfo';
import SignInfo from '../../templates/SignInfo';
import { KeyValue } from '../../types/KeyValue';
import ShowAgreementButton from '../../molecules/ShowAgreementButton';
import ShowContractButton from '../../molecules/ShowContractButton';
import ModernizationFundApplicationInfo from '../../templates/ModernizationFundApplicationInfo';
import ModernizationFundFooterButton from '../../organisms/FooterModernizationFundButton';

interface Props {
  step_navigation: StepType;
  reception_id: number;
  reception_cd: string;
  label: string;
  status_name: string;
  display_reception_cd: boolean;
  guide_text: string;
  status_code: number;
  is_staff: boolean;
  guarantors_num: number;
  is_loading: boolean;
  display_status: boolean;
  agreement_info: KeyValue[];
  sign_info: KeyValue[];
  review_approval_status_name: string; // 審査結果
  review_message: string; // お客様へのお知らせ
  is_guarantor: boolean;
  mp_flg: number; // 借入申込希望書兼経営改善資金計画書フラグ
  ma_flg: number; // 代化資金借入申込書フラグ
  handleDecline: () => void; //『辞退する』のモジュール
  handleExecution: () => void; //『申込内容を変更する』のモジュール
  is_signer: boolean;
}
const ModernisationFundingCaseDetails: React.FC<Props> = ({
  step_navigation,
  reception_id,
  reception_cd,
  label,
  status_name,
  display_reception_cd,
  guide_text,
  status_code,
  is_staff,
  guarantors_num,
  is_loading,
  display_status,
  agreement_info,
  sign_info,
  review_approval_status_name,
  review_message,
  is_guarantor,
  mp_flg,
  ma_flg,
  handleDecline,
  handleExecution,
  is_signer,
}) => {
  return (
    <>
      <TopArea
        step_navigation={step_navigation}
        reception_cd={reception_cd}
        label={label}
        status_name={status_name}
        display_reception_cd={display_reception_cd}
        guide_text={guide_text}
        display_status={display_status}
      />
      {/* お申込情報 */}
      <ModernizationFundApplicationInfo mp_flg={mp_flg} ma_flg={ma_flg} status_code={status_code} />

      {/* 審査結果アコーディオン */}
      {/* ※本審査結果登録以降に表示 */}
      {status_code >= status_code_list.borrowing_application_result_approval && (
        <ReceptionResult
          review_approval_status_name={review_approval_status_name}
          review_message={review_message}
        />
      )}

      {/* 連帯債務者等の同意不同意アコーディオン */}
      {/* 連帯債務者等が0人の場合は非表示、1人以上の場合は表示する */}
      {guarantors_num !== 0 && (
        <AgreementInfo agreement_info={agreement_info} heading_disabled={false} />
      )}

      {/* 署名情報アコーディオン */}
      {/* ※契約申込登録以降に表示する */}
      {status_code >= status_code_list.contract_document_register1 && (
        <SignInfo sign_info={sign_info} heading_disabled />
      )}

      {/* 同意書を表示するボタン */}
      <ShowAgreementButton reception_id={reception_id} />

      {/* 契約書を表示するボタン */}
      {/* ※契約申込登録以降に表示する */}
      {status_code >= status_code_list.contract_document_register1 && (
        <ShowContractButton reception_id={reception_id} is_signer={is_signer} />
      )}

      {/* フッター部 */}
      <ModernizationFundFooterButton
        reception_cd={reception_cd}
        reception_id={reception_id}
        status_code={status_code}
        mp_flg={mp_flg}
        ma_flg={ma_flg}
        handleDecline={handleDecline}
        handleExecution={handleExecution}
      />
      <LoadingModal show={is_loading} />
    </>
  );
};

export default ModernisationFundingCaseDetails;
